/**
 * Input for Checkup assessment (guided flow)
 */

import { useTranslation } from '@tonnie/locale';
import { Button, Input } from '@tonnie/ui';
import { Send } from '@tonnie/assets';
import { useCallback, useState } from 'react';

interface IChatInputProps {
  onSendMessage: (message: string) => void;
  isLoading: boolean;
}

export function ChatInput({ onSendMessage, isLoading }: IChatInputProps) {
  const { t } = useTranslation();
  const [input, setInput] = useState('');

  const handleSend = useCallback(() => {
    if (input.trim()) {
      onSendMessage(input);
      setInput('');
    }
  }, [input, onSendMessage]);

  return (
    <div className="p-4 border-t border-border bg-background">
      <div className="flex gap-2">
        <Input
          placeholder={t('checkup.chat.typeMessage')}
          aria-label={t('copilot.aria.messageInput')}
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyPress={(e) => e.key === 'Enter' && handleSend()}
          disabled={isLoading}
          className="text-sm"
          data-testid="guide-chat-input"
        />
        <Button
          onClick={handleSend}
          disabled={isLoading || !input.trim()}
          size="sm"
          className="px-4"
          data-testid="guide-chat-send"
          aria-label={t('copilot.aria.sendMessage')}
        >
          <Send className="w-4 h-4" aria-hidden="true" />
        </Button>
      </div>
    </div>
  );
}
